// extracted by mini-css-extract-plugin
export default {"root":"_3mlUxvzV","timerPeriod":"_3ONWUirN","counter":"A0RSkOPF","label":"_1QTUZ_BC"};